import React from "react";
import { useTranslation } from "src/context/Translations/context";
import { RCCGrid, RCCInput, RCCRadio } from "react-common-components";
import HierarchyProductLine from "../components/HierarchyProductLine";
import HierarchySalesChannel from "../components/HierarchySalesChannel";
import IOriginFinancialManagement from "../interface";
import ScreenBudgets from "../components/ScreenBudgets";
import HierarchyVariableExpenses from "../components/HierarchyVariableExpenses";

const VariableExpenses: React.FC = () => {
	const { translate } = useTranslation();
	return (
		<>
			<ScreenBudgets 
				origin={IOriginFinancialManagement.VARIABLE_EXPENSES}
				hierarchy1={({ofa001Id, onClickLine, ofa002Id}) => <HierarchySalesChannel ofa001Id={ofa001Id} onClickLine={onClickLine} ofa002Id={ofa002Id} />}
				hierarchy2={({ofa001Id, onClickLine, ofa002Id}) => <HierarchyProductLine ofa001Id={ofa001Id} onClickLine={onClickLine} ofa002Id={ofa002Id} />}
				hierarchy3={({ofa001Id, onClickLine, ofa002Id}) => <HierarchyVariableExpenses ofa001Id={ofa001Id} onClickLine={onClickLine} ofa002Id={ofa002Id} />}
				tabs={[{
					label: translate("Percentual"),
					value: "percentage",
					readOnlyColumn: false,
					readOnlyColumn2: true,
					showSaveButton: true,
					show: true
				},{
					label: translate("Valor"),
					value: "value",
					readOnlyColumn: true,
					readOnlyColumn2: false,
					showSaveButton: true,
					hideFromModalPopulate: true,
					show: true
				}]}
				keys={{
					link: "ofc001Linkexterno",
					id: "ofc001Id"
				}}
				lov1Label={translate("Canal de vendas")}
				lov2Label={translate("Produto/serviço")}
				lov3Label={translate("Deduções de venda")}
				configsComponent={({
					register,
					budget
				}) => <>
					<RCCGrid container item spacing={1}>
						<RCCGrid 
							container 
							item
							xs={12}
							sm={6}
						>
							<RCCRadio
								name="ofc001Variacao"
								register={register}
								label={translate("Variação")}
								color="purple"
								options={[
									{value: "1" ,label:translate("Planejado x Realizado")},
									{value: "2" ,label:translate("Realizado x Ano anterior")}
								]}
								defaultValue={budget.ofc001Variacao ? budget.ofc001Variacao.toString() : "1"}
							/>
						</RCCGrid>
						<RCCGrid 
							container 
							item
							xs={12}
							sm={6}
						>
							<RCCInput 
								name="ofc001Linkexterno"
								label={translate("Link")}
								maxLength={1000}
								register={register}
								defaultValue={budget.ofc001Linkexterno}
							/>
						</RCCGrid>
					</RCCGrid>
				</>}
			/>
		</>
	);
};

export default VariableExpenses;
